import { EmailService } from './../../email.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact-me',
  templateUrl: './contact-me.component.html',
  styleUrls: ['./contact-me.component.scss']
})
export class ContactMeComponent implements OnInit {

  constructor(private fb: FormBuilder, private contact: EmailService) { }

  ngOnInit(): void { }

  onSubmit(FormData: any) {
    console.log(FormData);
    this.contact.PostMessage(FormData)
      .subscribe((response: any) => {
        location.href = 'https://mailthis.to/confirm'
        console.log(response)
      }, (error: { responseText: any; }) => {
        console.warn(error.responseText)
        console.log({ error })
      })
  }

  FormData = this.fb.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
    project: [''],
    comment: [''],
  });

}
